module.exports = __webpack_public_path__ + "static/media/speakap.5b3e872c.svg";